import React from 'react';
import type {AssemblyTravelerStatusKind} from '../data/interfaces';

interface AssemblyTravelerStatusBadgeProps {
  className?: string;
  statusKind: AssemblyTravelerStatusKind;
}

interface AssemblyTravelerStatusBadgeDisplay {
  symbol: string;
  tooltip: string;
}

const ASSEMBLY_TRAVELER_STATUS_SYMBOLS = {
  ready: '🟢',
  coatings: '🎨',
  production: '🛠️',
} as const;

const BADGE_DISPLAY_BY_STATUS_KIND: Record<AssemblyTravelerStatusKind, AssemblyTravelerStatusBadgeDisplay> = {
  ready: {
    symbol: ASSEMBLY_TRAVELER_STATUS_SYMBOLS.ready,
    tooltip: 'ready to go',
  },
  coatings: {
    symbol: ASSEMBLY_TRAVELER_STATUS_SYMBOLS.coatings,
    tooltip: 'in coatings',
  },
  production: {
    symbol: ASSEMBLY_TRAVELER_STATUS_SYMBOLS.production,
    tooltip: 'in production',
  },
};

const AssemblyTravelerStatusBadge: React.FC<AssemblyTravelerStatusBadgeProps> = ({className, statusKind}) => {
  const display = BADGE_DISPLAY_BY_STATUS_KIND[statusKind];

  return (
    <span
      className={[
        'assembly-traveler-status-badge align-middle d-inline-flex align-items-center',
        className,
      ].filter(Boolean).join(' ')}
      title={display.tooltip}
      aria-label={`traveler status: ${display.tooltip}`}
    >
      <span aria-hidden className="assembly-traveler-status-badge-icon">
        {display.symbol}
      </span>
    </span>
  );
};

export default AssemblyTravelerStatusBadge;
